export class GlobalVariables {
 
    public static timeout: number = 10000;
    public static max_recent_routes = 4;

    public static routesUrl: string = "assets/json/routes.json";
    public static stopsUrl: string = "assets/json/stops.json";
    public static stationsUrl: string = "assets/json/stations.json";
    public static railTripsUrl: string = "https://www3.septa.org/api/TrainView/";
    public static busTripsUrl: string = "https://www3.septa.org/api/TransitViewAll/";

    public static pdfScheduleUrl: string = "https://s3.amazonaws.com/schedules.septa.org/current/";
    public static scheduledPdfUrl: string = "https://s3.amazonaws.com/schedules.septa.org/scheduled/pdf-schedule.json";

    public static busArrivalsUrl: string = "https://www3.septa.org/hackathon/BusSchedules/?req1=";
    public static calendarUrl = "https://s3.us-east-1.amazonaws.com/flat-api.septa.org/prod/v2/schedules/calendar/combined_calendar.json";
    public static serviceidsUrl = "https://s3.us-east-1.amazonaws.com/flat-api.septa.org/prod/v2/schedules/calendar/combined_service_ids.json";

    public static routeStopsUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/v2/stops/";

    public static tripScheduleUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/v2/schedules/trips/";
    public static tripScheduleExtension = "schedule.json";

    public static timetablesUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/v2/schedules/timetables";
    public static timetablesExtension = "timetable.json";

    public static stopScheduleUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/v2/schedules/stops/";
    public static stopScheduleExtension = "schedule.json";
    public static rssUrl: string = 'https://www3.septa.org/api/rss/';

    public static railRoutes: string[] = Array("AIR","CHE","CHW","LAN","MED","FOX","NOR","PAO","CYN","TRE","WAR","WIL","WTR","GC");

    public static earlyStatus: string = "min early";
    public static onTimeStatus: string = "On-time";
    public static lateStatus: string = "min late";
    public static canceledStatus: string = "Canceled";
    public static untrackedStatus: string = "Untracked";
    public static suspendedStatus: string = "Suspended";

    public static adaAlertTrue: string = "Alert Icon - Currently active";
    public static adaAlertFalse: string = "Alert Icon - Currenttly inactive";
    public static adaAdvisoryTrue: string = "Advisory Icon - Currently active";
    public static adaAdvisoryFalse: string = "Advisory Icon - Currenttly inactive";
    public static adaDetourTrue: string = "Detour Icon - Currently active";
    public static adaDetourFalse: string = "Detour Icon - Currently inactive";
    public static adaElevatorTrue: string = "Elevator Icon - Currenttly active";
    public static adaElevatorFalse: string = "Elevator Icon - Currenttly inactive";
    
}